/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

export function ProductTileSkeleton() {
    return (
        <Card className="product-tile-skeleton overflow-hidden w-full min-w-0 max-w-full flex flex-col h-full gap-0 py-0">
            {/* Media */}
            <CardHeader className="p-0">
                <Skeleton className="aspect-square w-full" />
            </CardHeader>

            {/* Info — mirrors the tile's four fields, flush to the edge with no horizontal
                padding, so the placeholder and the resolved tile occupy the same box.
                CRCB2B-100 removed the swatch row, the brand line and the rating; a skeleton
                that still reserves space for them is a layout shift on every resolve. */}
            <CardContent className="flex flex-col gap-1 px-0 pt-2 pb-0">
                {/* Product name */}
                <Skeleton className="h-5 w-3/4" />
                <div className="flex flex-col gap-0.5">
                    {/* Model number */}
                    <Skeleton className="h-4 w-24" />
                    {/* Price + tier label */}
                    <Skeleton className="h-5 w-32" />
                </div>
            </CardContent>
        </Card>
    );
}
